export class SectorOverviewItem {
    public id: string;
    public bdSectorId: string;
    public name: string;

    constructor();
    constructor(json: any);
    constructor(json?: SectorOverviewItem) {
        if (json) {
            Object.assign(this, json);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/models/sector/sector-overview-item.ts